import { Component, OnInit } from "@angular/core";
import * as moment from "moment";
import { MainService } from "../../main.service";
import {
  ModalDismissReasons,
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";
import { MatSnackBar } from "@angular/material";
@Component({
  selector: "app-saved-choirs",
  templateUrl: "./saved-choirs.component.html",
  styleUrls: ["./saved-choirs.component.scss"],
})
export class SavedChoirsComponent implements OnInit {
  questList: any = [];
  currentTime = "";
  user: any;
  searchText;
  any;
  isLoading: boolean = false;
  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
  };
  closeResult: string;
  private modalRef: NgbModalRef;
  constructor(
    private mainservice: MainService,
    private modalService: NgbModal,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    //  this.currentTime =  this.greeting()
    //  this.user = JSON.parse(localStorage.getItem('userData'));
    //  console.log('this.',this.questList)
    this.getSavedChoirList("");
  }

  greeting() {
    const hour = moment().hour();

    if (hour > 16) {
      return "Good evening";
    }

    if (hour > 11) {
      return "Good afternoon";
    }

    return "Good morning";
  }

  ChoirList = [];

  getSavedChoirList(text) {
    this.isLoading = true;
    let query = "text=" + text;
    this.mainservice.getSavedChoirApi(query).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.ChoirList = res.data.savedChoirs;
          console.log(this.ChoirList, "res");
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  scholardetail: any;
  OpenModal(content, btn, data) {
    this.scholardetail = data;
    this.modelOptions = {
      backdrop: true,
      keyboard: false,
      centered: true,
      size: "lg",
    };
    btn &&
      btn.parentElement &&
      btn.parentElement.parentElement &&
      btn.parentElement.parentElement.blur();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  closeModal() {
    this.modalRef.close();
    this.questList = [];
  }
  // convertSecondsToDate(seconds) {
  //   const date = new Date(seconds * 1000);
  //   const day = String(date.getDate()).padStart(2, "0");
  //   const month = String(date.getMonth() + 1).padStart(2, "0");
  //   const year = String(date.getFullYear()).slice(-2);
  //   return `${day}/${month}/${year}`;
  // }
  convertSecondsToDate(seconds: number): string {
    const date = new Date(seconds * 1000);
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return date.toLocaleDateString("en-US", options);
  }
  choosedFile: File;
  onPicsfileChanged(event, index) {
    this.isLoading = true;
    this.choosedFile = event.target.files[0];
    if (event.target.files.length == 0) {
      this.isLoading = false;
      false;
    }

    this.mainservice.uploadImage(this.choosedFile).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.questList[index]["valuesText"] = res.data.url;
        } else {
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }
  // END ----- Update user status block
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
}
